<template>
  <div class="widget-container" :class="{ 'widget-container--mobile': mobile }">
    <!-- Header -->
    <div class="widget-header" :class="{ 'widget-header--mobile': mobile }">
      <div class="widget-header__inner" :class="{ 'widget-header__inner--mobile': mobile }">
        <span class="widget-title" :class="{ 'widget-title--mobile': mobile }">{{ mobile ? 'Cajas' : 'Stands' }}</span>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="widget-search"
          single-line
          hide-details
          dense
        ></v-text-field>
      </div>
      <v-divider></v-divider>
    </div>
    <!-- List -->
    <div class="widget-list" :class="{ 'widget-list--desktop': !mobile }">
      <v-data-table
        @click:row="goResource"
        hide-default-footer
        hide-default-header
        :search="search"
        :headers="headersStands"
        :items="arrStands"
        :items-per-page="arrStands.length"
        :item-class="rowClass"
        :mobile-breakpoint="mobile ? 0 : undefined"
        :dense="mobile"
      >
        <template v-slot:item.icon="{ item }">
          <v-icon :color="(item.operative === 1) ? 'admiraGreen' : 'gray'">{{ item.icon }}</v-icon>
        </template>
        <template v-slot:item.operative="{ item }">
          <v-switch
            :input-value="item.operative"
            color="admiraGreen"
            @click.stop="statusOperative(item.idResource)"
            :hide-details="mobile"
            :dense="mobile"
          ></v-switch>
        </template>
      </v-data-table>
      <div v-if="!mobile" class="widget-spacer"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "StandsList",
  data: () => ({
        search: '',
        mobile: false,
  }),
  components: {},
  computed: {
    ...mapState("queues", [
      "spaceSelected",
      "allResouces",
    ]),
    ...mapState("app", ["actualProject"]),
    headersStands() {
      return [
        { text: "icon", value: "icon", align: "start" },
        { text: "nombre", value: "name" },
        { text: '', value: 'operative', active: true, sortable: false, width: '20px',align: 'right'}
      ];
    },
    arrStands() {
      let allResouces = this.allResouces;
      allResouces = allResouces.filter(
          resource => resource.space == this.spaceSelected.idSpace
        );

      return allResouces.map((resource) => {
        return {
          ...resource,
          icon: "mdi-store",
        };
      });
    },
  },
  methods: {
    ...mapMutations("queues", [
      "spaceActions",
    ]),
    ...mapActions("queues", [
      "getTicketStore",
      "getTicketAttended",
      "changeOperative"
    ]),
    rowClass(resource){
     return (resource.operative === 1) ? "allowed" : "not-allowed"
    },
    statusOperative(idResource){
     this.changeOperative(idResource)
    },
    async goResource(resource) {
      if (resource.operative === 1){
        this.spaceActions(resource);
        await this.getTicketStore(resource.idResource);
        await this.getTicketAttended(resource.idResource);
        if (this.mobile == true) {
                this.$router.push({
          name: "GeneralStandTurnMobile",
          params: { idSpace: resource },
        });
        }else{
        this.$router.push({
          name: "GeneralStandTurn",
          params: { idSpace: resource },
        });
        }
      }
    },
  },
  created() {
     var mobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
      }
    };
        
    if(mobile.any() != null){
        this.mobile = true
    }else{
      this.mobile = false
    }
  },
  mounted() {},
  destroyed() {},
};
</script>
<style lang="css">
.allowed {
  cursor: pointer;
}
.not-allowed {
  cursor: not-allowed;
}
</style>
<style scoped>
.widget-container {
  display: flex;
  flex-direction: column;
  height: calc(36vh);
  overflow: hidden;
}
.widget-container--mobile {
  height: auto;
  max-height: 40vh;
}
.widget-header {
  flex-shrink: 0;
  padding: 0 16px;
}
.widget-header--mobile {
  padding: 8px 16px;
}
.widget-header__inner {
  display: flex;
  align-items: center;
  padding: 12px 0;
}
.widget-header__inner--mobile {
  padding: 0;
}
.widget-title {
  color: #777;
  font-size: 18px;
  white-space: nowrap;
}
.widget-title--mobile {
  font-size: 16px;
}
.widget-search {
  flex: 1;
  margin: 0 12px;
}
.widget-list {
  flex: 1;
  overflow: auto;
  padding: 4px 16px;
}
.widget-list--desktop {
  margin: 0 8px 0 0;
  padding: 0 8px 16px 16px;
}
.widget-spacer {
  height: 16px;
}
>>> td {
  border: none !important;
}
>>> th {
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/components/StandsList.vue